<form [formGroup]='formGroup'
      class='widget'>
  <div class='form-group'>
    <pt-input-label
      *ngIf='label'
      [inputId]='inputId'
      [isRequired]='isRequired'
      [label]='label'
      style='display: contents'
    ></pt-input-label>
    <input [class.is-invalid]='isChanged && formGroup.invalid'
           [id]='inputId'
           aria-describedby='ptWInputHelp'
           autocomplete='off'
           class='form-control form-control-sm'
           formControlName='value'
           placeholder='{{placeholder}}'
           type='text'>

    <ng-container *ngIf='showErrorMessageContainer()'>
      <div *ngIf='showErrorMessage()' class='small error-message'>
        {{ 'MESSAGE.ALREADY_TAKEN' | translate }}
      </div>
    </ng-container>
  </div>
</form>
